import { render, staticRenderFns } from "./app.vue?vue&type=template&id=2e22966c"
import script from "./app.js?vue&type=script&lang=js&external"
export * from "./app.js?vue&type=script&lang=js&external"
import style0 from "./app.vue?vue&type=style&index=0&id=2e22966c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports